package com.downdogapp.client

/**
 * AUTO-GENERATED DO NOT EDIT!
 * from com.downdogapp.tasks.AppStrings
 */
// @formatter:off 
object MandarinStrings : LanguageStrings {
  // https://worker.downdogapp.com/debug/appString?appStringId=488
  override fun ABBREVIATED_MEMBERSHIP_WILL_NOT_RENEW(p0: Any) = "已取消，${p0}到期"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=498
  override val ACCOUNT = "賬戶"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2588
  override val ACCOUNT_INELIGIBLE_FOR_REFERRAL_MESSAGE = "看起来你已经有一个帐户！只有新帐户才有资格通过推荐获得免费会员资格。对不起！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1467
  override val AFFILIATE_ANSWER = "感谢您的关注！我们已经停止了我们的联盟计划，所以很遗憾不能。抱歉！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1466
  override val AFFILIATE_QUESTION = "你們有分銷模式嗎？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1299
  override val AFFORDABILITY = "申請資助"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1300
  override val AFFORDABILITY_FEEDBACK_PROMPT = "請幫助我們了解您的情況"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=518
  override val AFFORDABILITY_MESSAGE = "我們的目標是為世界各地的用戶提供高質量且價格實惠的健身練習。如果Down Dog目前不在您的預算範圍內，請來信說明現狀，我們看看能怎樣為您提供幫助！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3950
  override val AIRPLAY = "Airplay"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1409
  override val AIRPLAY_ANSWER = "您可以通過AirPlay的屏幕鏡像功能播放Down Dog練習！請訪問<a href=\"https://support.apple.com/en-us/HT204289\">Apple的指南頁面</a>以查閱更多信息。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1408
  override val AIRPLAY_QUESTION = "你們是否支持AirPlay？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1292
  override val ALL = "所有APP"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1255
  override val ALL_APPS = "所有APP"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1453
  override val ALL_APPS_PURCHASE_ANSWER = "目前，購買訂閱即可解鎖我們全系列APP，包括「Down Dog下犬瑜伽」、「HIIT高強度間歇訓練」、「Barre芭蕾健身」和「孕期瑜伽」！\n\n我們目前不提供購買單個APP的選項。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1452
  override val ALL_APPS_PURCHASE_QUESTION = "我的訂閱能解鎖單個APP還是所有APP？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3110
  override val ALL_POSES = "所有姿势"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1295
  override fun AMOUNTS_CURRENCY_PAYMENTS_SECURE_MESSAGE(p0: Any) = "${p0}中顯示的所有金額。您的付款信息已安全加密。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=113
  override val AND = "和"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1589
  override val APPLE = "Apple"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1403
  override val APPLE_HEALTH_ANSWER = "可以！如果您在連接時遇到問題，請參考以下貼士：\n\n1. 確保您的APP已連接Apple健康。首先請打開APP並前往菜單（右下角的漢堡按鈕）：是否有看到「連接Apple健康APP」的選項？如果有的話，請點擊選擇。\n2. 在手機上打開Apple健康APP，點擊數據來源分頁。列表中是否有將Down Dog列為數據來源之一？如果並沒有（而APP內也並未提供連接的選項），請向我們來信。\n3. 請嘗試卸載並重新安裝APP，然後重新登陸，再嘗試連接Apple健康。\n\n很遺憾，iPad並不支持Apple健康；我們也並不支持跨設備追蹤練習的功能（雖然未來可能會提供此功能）。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1402
  override val APPLE_HEALTH_QUESTION = "APP可以連接Apple健康APP嗎？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1420
  override fun APPLE_REFUND_POLICY(p0: Any) = "很遺憾，如果您通過APP商城購買了訂閱，Apple不允許我們替您取消或提供退款。這是來自Apple有關取消訂閱的指南：${p0}\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1425
  override val ASK_IN_FACEBOOK_GROUP = "前往Facebook群組提問"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=490
  override val AUTO_RENEW_IS_OFF = "關閉自動續訂"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=489
  override val AUTO_RENEW_IS_ON = "自動續訂已開啟"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1221
  override val AUTO_RENEW_OFF_ANSWER = "<b>如何管理或取消訂閱</b>\n\n如果您曾通過<em>官網</em>購買訂閱：\n1. 請前往<b>設置</b>界面。在移動客戶端上，請點擊屏幕右下角的三條橫線。在網頁版中，「設置」在左側欄裡。\n2. 在<b>設置</b>界面下，點擊<b>訂閱</b>。\n3. 然後您會看到更多信息，包括如何取消或更改訂閱，以及關閉自動續訂功能。\n\n如果您曾通過<em>移動客戶端</em>購買訂閱，您可以通過 <a href=\"https://support.apple.com/zh-cn/HT202039\" target=\"_blank\">Apple APP商城</a>或<a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=zh-Hans\" target=\"_blank\">Google Play商城</a>管理訂閱。\n\n<b>有關您的訂閱</b>\n\n除非您通過我們的官網、Apple或Google專門購買了訂閱，否則我們絕不會向您收取訂閱費用。您可以在購買時使用的電郵地址下查看訂閱。如果您的賬號中並未顯示訂閱，這意味著您目前登陸的電郵地址並無有效訂閱。也許您的訂閱和另一個電郵地址關聯。如果是這種情況，您需要退出登陸，然後使用該電郵地址重新登陸，才能查看您的訂閱。\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1211
  override val AUTO_RENEW_OFF_QUESTION = "我想關閉自動續訂功能。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=252
  override val BACK = "返回"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=787
  override val BARRE = "芭蕾健身Barre"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=759
  override val BARRE_GOOGLE_FIT_DESCRIPTION = "芭蕾健身"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1432
  override val BILLING = "賬單"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1258
  override val BILLING_REFUND = "賬單—退款"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=332
  override val BREATHING = "呼吸"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2538
  override val BREATHING_GOOGLE_FIT_DESCRIPTION = "呼吸练习"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=263
  override val CANCEL = "取消"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2564
  override val CANCEL_DOWNLOAD = "取消下载"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1470
  override val CANNOT_MERGE_ACCOUNTS_ANSWER = "很抱歉，我們無法合併您的賬戶。\n\n請使用購買訂閱時的賬號登陸，以確保您能正常訪問訂閱！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1469
  override val CANNOT_MERGE_ACCOUNTS_QUESTION = "我有多個賬戶。可以把它們合併嗎？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1305
  override val CANT_ACCESS_SUBSCRIPTION_ANSWER = "您可能不小心创建了多个 Down Dog 帐户。您应该尝试退出应用程序并使用您可能使用过的任何其他电子邮件地址重新登录。请注意，您的订阅适用于我们所有的应用程序和您的所有设备（包括网络版本），但您必须使用购买时使用的同一电子邮件地址登录。 <em>请注意，Apple、Google 和 PayPal 可能已将收据发送到您与这些服务关联的电子邮件地址，而不是您用于登录 Down Dog 的电子邮件地址</em>。\n\n如果您使用 Apple iTunes 或 Google Play 从移动应用程序中订阅，您应该尝试从应用程序的菜单中单击<b>恢复应用内购买</b>。请务必在您进行原始购买的同一应用程序中执行此操作。\n\n如果您通过 PayPal 订阅并且您无权访问您的订阅，则您的付款很可能没有成功。您可以在您的 PayPal 帐户中进行检查，也可以通过访问应用程序的设置来查看仅持续几天的订阅。如果是这种情况，您实际上并未被收取费用，您可以通过访问我们的网站尝试再次购买。与使用 PayPal 相比，直接使用信用卡付款可能会更成功。\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1304
  override val CANT_ACCESS_SUBSCRIPTION_QUESTION = "我無法訪問我的訂閱。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3949
  override val CAST = "投放"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1203
  override val CAST_ANSWER = "可以，我們最近為APP移動客戶端和網頁版添加了Chromecast功能支持。\n\n如何通過移動客戶端使用Chromecast：\n1. 請確保您已開啟Chromecast適用的設備（例如電視），並且和您的安卓或iOS設備使用同一WIFI無線網路。同時，請確認您已更新至APP最新版本。\n2. 開始練習。\n3. 點擊屏幕以顯示選項，然後選擇右上角的<b>Chromecast按鈕</b>（看起來像長方形一角有三個四分之一圓）。\n4. 稍等（最多一分鐘）練習加載至電視，然後在安卓或iOS設備上點擊播放。\n\n如何通過網頁版使用Chromecast：\n1. 請確保您已開啟Chromecast適用的設備（例如電視），並且和電腦使用同一WIFI無線網路。\n2. 使用<b>Chrome</b>瀏覽器，在APP網頁版中開始練習。\n3. 點擊右下角的<b>Chromecast按鈕</b>（看起來像長方形一角有三個四分之一圓）。\n4. 稍等（最多一分鐘）練習加載至電視，然後在電腦上點擊播放。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1191
  override val CAST_QUESTION = "APP可以支持Chromecast嗎？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1349
  override val CAST_TROUBLESHOOTING_ANSWER = "<b>如果「投射」按鈕沒有出現：</b>\n\n1. 開始練習，然後暫停。現在是否能看到「投射」按鈕（安卓或iOS設備右上角；網頁版右下角）？我們只有在練習播放過程中才展現「投射」按鈕。\n\n2. 試試用同一設備投射其他內容（比如Youtube等視頻網站）。現在是否能看到「投射」按鈕？如果仍未看見，請確保您已開啟Chromecast適用的設備（例如電視），並且和您的安卓或iOS設備使用同一WIFI無線網路。如果您正在通過電腦使用網頁版，請確保您在使用Chrome瀏覽器。\n\n3. 試著從另一個設備投射內容。如果您之前在用安卓或iOS設備，請嘗試通過電腦從網頁版APP進行投射，反之亦然。\n\n4. 在手機上為Down Dog系列的APP關閉電池優化功能，讓此APP能和Chromecast設備保持持續通訊，而不是在閒置幾分鐘後就進入省電模式。\n\n<b>如果您已成功「連接」，但視頻卻無法播放：</b>\n\n首先，請確保您已稍加等待，讓Down Dog有足夠的時間加載至您的電視。加載過程一般可長達60秒。在這期間，電視會一開始在屏幕下方展現黃色的「加載」條，然後屏幕退回至全黑。您的電視會在加載完畢後為您展現視頻內容。\n\n如果60秒過後，電視屏幕依然全黑，或者「Down Dog」字樣在全黑屏幕中間出現，那麼便請退出練習，然後重試。如果想重新開始同一練習，請前往「歷史」界面（安卓或iOS屏幕下方的時鐘圖標；網頁版左側欄）。\n\n<b>如果您的投射在播放幾分鐘後便斷開連接：</b>\n\n1. 請檢測您的WiFi信號強度。如果您的Chromecast或手機/電腦的信號較弱，您可以通過使用WiFi無限訊號延伸器或將設備移到更靠近路由器的位置，以此增加訊號強度。\n\n2. 在手機上為Down Dog系列的APP關閉電池優化功能，讓此APP能和Chromecast設備保持持續通訊，而不是在閒置幾分鐘後就進入省電模式。\n\n3. 如果仍未解決問題，您也可以試著重啟路由器。\n\n4. 最後，可嘗試調整您的手機Wifi連接設置，讓它使用靜態IP地址。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1348
  override val CAST_TROUBLESHOOTING_QUESTION = "我在使用Chromecast時遇到了問題。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=997
  override fun CASTING_TO_DEVICE(p0: Any) = "投射到${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3302
  override val CHALLENGE_EMAIL_NOTIFICATIONS_TEXT = "电子邮件"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3470
  override val CHALLENGE_EMAIL_UPDATES_TEXT = "电子邮件"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3468
  override val CHALLENGE_ENROLL_CHALLENGE_UPDATES_SUBHEADER = "挑战更新"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3469
  override val CHALLENGE_ENROLL_CHALLENGE_UPDATES_SUBTEXT = "获取关于社区和您挑战进度的更新！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3466
  override val CHALLENGE_ENROLL_DAILY_REMINDERS_SUBHEADER = "每日提醒"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3467
  override val CHALLENGE_ENROLL_DAILY_REMINDERS_SUBTEXT = "在一月份每天收到练习提醒！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3809
  override val CHALLENGE_FAQ_A1 = "答：要完成挑战，您必须在本月的每一天完成一次练习。您可以使用任何 Down Dog 应用程序。练习必须全部完成。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3811
  override val CHALLENGE_FAQ_A2 = "答：Down Dog 会使用您应用程序的“旅程”页面上的日历来跟踪您的进度！每天当您练习并看到日历日期显示为蓝色时，这就被记录为您的挑战进度。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3814
  override val CHALLENGE_FAQ_A3 = "答：我们会根据您前一天的练习时间发送每日提醒。因此，如果您比平时更早练习，可能会比我们的提醒更早！只要您在“旅程”页面的日历上看到您的练习被记录，它们就会计入您的挑战进度。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3816
  override val CHALLENGE_FAQ_A4 = "答：不行。非常抱歉，我们无法将未在 Down Dog 应用程序上完成的练习添加到您的历史记录中。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3818
  override val CHALLENGE_FAQ_A5 = "答：如果您正在旅行并更改时区，这可能会影响您的挑战连续记录。目前，我们的系统会根据您练习时所在的时区记录您的练习历史。这意味着您的练习日期将与您当前的时区对齐，而不是您原来的时区。为了保持您的连续记录，我们建议您尽可能在与原始时区一致的时间进行练习。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3820
  override val CHALLENGE_FAQ_A6 = "答：获胜者是从完成挑战的用户群中随机选出的。挑战结束时，获胜者将被单独联系。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3808
  override val CHALLENGE_FAQ_Q1 = "问：有什么要求？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3810
  override val CHALLENGE_FAQ_Q2 = "问：我的进度是如何跟踪的？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3813
  override val CHALLENGE_FAQ_Q3 = "问：我已注册每日通知，但今天没有收到，是不是出了什么问题？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3815
  override val CHALLENGE_FAQ_Q4 = "问：我在其他地方完成了一次练习——可以将其添加到我的应用历史记录中吗？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3817
  override val CHALLENGE_FAQ_Q5 = "问：我在挑战期间旅行。这会有什么影响吗？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3819
  override val CHALLENGE_FAQ_Q6 = "问：商品获奖者是如何被选中和联系的？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3807
  override val CHALLENGE_FAQ_TITLE = "Down Dog 挑战常见问题解答"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3465
  override val CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TEXT = "您已选择不接收任何通讯，因此您将不会收到来自 Down Dog 关于挑战的任何进度更新或提醒。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3471
  override val CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TITLE = "您确定吗？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3303
  override val CHALLENGE_PUSH_NOTIFICATIONS_TEXT = "推送通知"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3317
  override val CHALLENGE_RESUBSCRIBE_TO_EMAILS_ALERT_TEXT = "注意！您之前选择不接收 Down Dog 的电子邮件通讯。通过在挑战中启用电子邮件通讯，我们将自动重新启用您的账户以接收我们的电子邮件通讯。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1218
  override val CHANGE_EMAIL_ANSWER = "1. 前往<b>設置</b>菜單。在移動客戶端，點擊屏幕右下角的三條橫線進入<b>設置</b>。在網頁版，從左側欄中找到<b>設置</b>。\n2. 在<b>賬戶</b>界面下，選擇<b>郵箱</b>然後輸入您想使用的郵箱地址\n3. 點擊<b>保存</b>"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1208
  override val CHANGE_EMAIL_QUESTION = "如何更改與賬號關聯的電子郵箱地址？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=152
  override val CHANGE_LANGUAGE = "更改語言"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1159
  override val CHANGE_LANGUAGE_ANSWER = "<b>瑜伽，产前，冥想，HIIT</b>\n\n您可以通过导航到<b>设置</b>来更改语言（在移动应用程序上，点击右下角的3条水平线，在网络应用程序上，设置将在左侧边栏上），然后点击<b>语言</b>！\n\n<b>巴雷</b>\n\n目前，此应用程序仅提供英文版本。即使更改语言后，您仍会听到英文指令。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=327
  override val CHANGE_LANGUAGE_NO_INTERNET_MESSAGE = "誒，您需要連接網絡才能更改語言。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1158
  override val CHANGE_LANGUAGE_QUESTION = "如何切換人聲講解的語言？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1219
  override val CHANGE_PASSWORD_ANSWER = "1. 前往<b>設置</b>頁面。在移動客戶端上，請點擊屏幕右下角的三條橫線。在網頁版中，選擇左側欄中的<b>設置</b>。\n2. 在<b>賬戶</b>界面下，點擊<b>密碼</b>，在「密碼」一欄和「確認密碼」一欄中輸入您想使用的新密碼\n3. 點擊<b>保存</b>\n\n如果您忘了密碼，只需在登陸界面輸入您的郵箱地址和一個錯誤的密碼。然後，點擊<b>密碼忘了？</b>選項。\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1209
  override val CHANGE_PASSWORD_QUESTION = "如何更改密碼？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1142
  override val CHANGE_PLAYLIST_TYPE_ANSWER = "我們提供多種風格的音樂，並會持續添加新的選擇！在APP中，您可以在設置界面裡上滑並選擇<b>音樂</b>以切換音樂風格！在網頁版中，您可以滑動瀏覽設置界面，然後點擊<b>音樂</b>選項"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1141
  override val CHANGE_PLAYLIST_TYPE_QUESTION = "如何切換背景音樂風格？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=52
  override val CHANGE_VISUAL_TYPE_NO_INTERNET_MESSAGE = "誒，您需要連接網絡才能更改本次練習的屏幕內容。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1157
  override val CHANGE_VOICE_ANSWER = "<b>瑜伽，产前，冥想，和HIIT</b>\n\n我们目前在这些应用中提供多种英语发音。在移动设备上，您可以通过在主设置页面上滑，然后点击<b>语音</b>来更改您听到的声音。在网页上，您可以滚动设置并点击<b>语音</b>选项。\n\n我们还在这些应用中提供了几种非英语发音。您可以通过导航到<b>设置</b>（在移动应用上，点击右下角的3条水平线，在网页应用上设置将在左侧边栏上）然后点击<b>语言</b>来更改语言！\n\n<b>芭蕾</b>\n\n目前只有一种语音，但我们计划在未来添加更多语言和语音。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1156
  override val CHANGE_VOICE_QUESTION = "如何切換人聲？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1441
  override val CHARGED_TWICE = "我被重複扣款了。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1433
  override fun CHECK_OUT_QUESTION(p0: Any) = "請查看我們的${p0}，也許您的提問已有答案。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=482
  override val CLEAR_PRACTICE_HISTORY_CONFIRM_MESSAGE = "您確認要刪除練習歷史記錄中的所有練習嗎？此操作無法撤銷。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=275
  override val CLOSE = "關閉"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1180
  override val COMMUNITY_ANSWER = "我們在Facebook上有一個非常活躍而溫馨的<a href=\"https://www.facebook.com/groups/183894272193568/\" target=\"_blank\">Down Dog Community</a>社區群組，歡迎加入我們尋求建議或分享您的練習進度！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1172
  override val COMMUNITY_QUESTION = "我很想加入一個社區，在探索健身的過程中相互支持！你們有沒有相關的社群，讓我在疑惑的時候可以尋求支持？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1394
  override val COMPANIES_FREE_UNTIL_JUNE_1_LONG = "遠程辦公的居家員工可申領有效期至6月1日的免費會員資格！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2563
  override val CONFIRM_CANCEL_OFFLINE_DOWNLOAD = "您确定要取消此下载吗？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2561
  override val CONFIRM_DELETE_OFFLINE_PRACTICE = "您确定要删除此离线练习吗？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=428
  override val CONFIRM_PASSWORD = "確認密碼"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1
  override val CONNECT_TO_APPLE_HEALTH = "連接Apple健康APP"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=93
  override val CONNECT_TO_GOOGLE_FIT = "連接Google Fit"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2
  override val CONNECTED_TO_APPLE_HEALTH_MESSAGE = "您的練習將會被自動記錄到Apple健康APP！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=94
  override val CONNECTED_TO_GOOGLE_FIT_MESSAGE = "您的練習將會被自動記錄到Google Fit！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1009
  override val CONNECTING_TO_CHROMECAST = "正在連接……"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=25
  override val CONNECTION_PROBLEM = "連接出錯"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=264
  override val CONTACT = "聯繫我們"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1421
  override val CONTACT_APPLE_FOR_REFUND = "如果您想申請退款，請聯繫Apple客服，通知他們我們可以進行退款。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=265
  override val CONTINUE = "繼續"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=437
  override val CORPORATE_MEMBERSHIP = "企業會員資格"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=616
  override val COUNTDOWN_TIMER = "倒計時"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2550
  override val CREATE_OFFLINE_PRACTICE = "创建离线练习"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2562
  override val CREATE_OFFLINE_PRACTICE_EXPLANATION = "使用您当前的设置创建和下载练习？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1604
  override val CUSTOM = "自定義"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=266
  override val DELETE = "刪除"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=399
  override val DELETE_ACCOUNT = "刪除賬號"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=487
  override val DELETE_ACCOUNT_AND_STOP_PAYMENTS_CONFIRM_MESSAGE = "您的賬號將被【所有】Down Dog旗下的APP【永久】刪除；我們將自動取消您的訂閱。是否確認繼續？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1220
  override val DELETE_ACCOUNT_ANSWER = "如果您決定離開我們的社區，則可以通過移動客戶端或APP網頁版刪除賬號。請留意：賬號一經刪除便不可恢復，您將丟失所有歷史及收藏夾中的練習！\n\n1. 前往<b>設置</b>菜單。在移動客戶端，您可點擊屏幕右下角的三條橫線進入<b>設置</b>。在網頁版，您可以在左側欄中找到<b>設置</b>。\n2. 在<b>設置</b>菜單中，下滑來到<b>我的數據</b>，然後點擊<b>刪除賬號</b>\n3. 當提示窗口彈出時，選擇<b>確認</b>\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=485
  override val DELETE_ACCOUNT_CONFIRM_MESSAGE = "您確認要刪除此賬號嗎？此操作無法撤銷。您的賬號會在所有Down Dog旗下的APP中被永久刪除。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1210
  override val DELETE_ACCOUNT_QUESTION = "如何刪除我的賬號？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1556
  override val DELETE_ACCOUNT_RECONFIRM_MESSAGE = "您即將永久刪除您在Down Dog全系列APP中的賬戶。此操作無法撤銷！您確認要繼續嗎？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=486
  override val DELETE_ACCOUNT_WITHOUT_STOPPING_PAYMENTS_CONFIRM_MESSAGE = "您的賬號將被【所有】Down Dog旗下的APP永久刪除。除非您自行取消，否則您的訂閱將會【持續收費】。是否確認？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=467
  override val DELETE_HISTORY = "清空練習歷史記錄"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2565
  override val DELETE_OFFLINE_PRACTICE = "删除线下练习"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1351
  override val DEVICE_LIMIT_ANSWER = "可以！請確保您使用購買訂閱時的同一電郵地址登陸。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1306
  override val DEVICE_LIMIT_QUESTION = "我能否在所有設備（電腦、手機、平板等）上使用已訂閱賬號？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1501
  override val DIDNT_PURCHASE_SUBSCRIPTION = "您尚未購買訂閱。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3946
  override val DISLIKE = "不喜欢"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1502
  override val DONT_SEE_SUBSCRIPTION = "我沒有看到我的訂閱"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=629
  override val DOWNLOAD = "下載"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2557
  override val DOWNLOAD_EXPLANATION = "下载完成后，您可以在离线练习页面中找到此练习。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2559
  override val DOWNLOAD_PRACTICE = "下载练习"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2556
  override val DOWNLOAD_STARTED = "下载开始"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2555
  override fun DOWNLOADING_VIDEO_PROGRESS(p0: Any) = "正在下载... ${p0}%"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3947
  override val EDIT = "编辑"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=491
  override val EDIT_EMAIL = "編輯電郵"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=628
  override val EDIT_NAME = "編輯名稱"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=492
  override val EDIT_PASSWORD = "更改密碼"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=462
  override val EMAIL = "郵箱"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=137
  override val EMAIL_AND_PASSWORD = "郵箱和密碼"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=197
  override val ENGLISH_POSE_NAMES = "英文體式名稱"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3370
  override fun ENROLL_CHALLENGE_ENABLE_PUSH_NOTIFICATIONS_INSTRUCTIONS(p0: Any) = "1. 打开您的设置应用程序。\n\n2. 导航至通知。\n\n3. 找到${p0}应用程序，并确保<b>通知已启用。</b>"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3304
  override val ENROLL_CHALLENGE_ENABLE_PUSH_NOTIFICATIONS_PROMPT = "请确保您已在移动设备上为Down Dog启用推送通知。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=146
  override val ENTER_CODE = "輸入禮品代碼"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=138
  override val ENTER_EMAIL_ADDRESS = "輸入郵箱地址"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=139
  override val ENTER_PASSWORD = "輸入密碼"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2170
  override val EQUIPMENT = "设备"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=88
  override val ERROR_CONNECTING_TO_APPLE_HEALTH_MESSAGE = "誒，連接健康APP時出錯。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=56
  override val ERROR_CONNECTING_TO_GOOGLE_FIT_MESSAGE = "誒，連接Google Fit時出錯。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=57
  override val ERROR_OCCURRED_MESSAGE = "發生錯誤。請聯繫我們獲得解決方案。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1198
  override val EXCLUDE_POSES_ANSWER = "<b>「HIIT高強度間歇訓練」</b>\n\n可以。在「練習」設置下，點擊<b>內容組合</b>。然後，點擊每一個身體部位左邊的+符號，就會看到一系列練習名稱。點擊個別練習，它就不會在課程期間出現。\n\n<b>「瑜伽」、「孕期瑜伽」、「Barre芭蕾健身」</b>\n\n我們目前暫不提供這個功能，但我們已將它列入開發計劃！目前，如果您想跳過某個不喜歡的體式，可以在移動客戶端裡<b>往左劃</b>；在網頁版裡，選擇屏幕左下方的<b>快進箭頭</b>。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1187
  override val EXCLUDE_POSES_QUESTION = "我能不能在練習中完全避開某些體式？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1262
  override val EXERCISE_ADVICE = "健身咨詢"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1602
  override val EXERCISE_LIST = "練習列表"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3254
  override val EXERCISE_NAMES = "运动名称"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=267
  override val EXIT = "退出"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=268
  override val EXIT_PRACTICE = "退出練習"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=156
  override val EXIT_PRACTICE_MESSAGE = "確認離開本次練習？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2720
  override val EXPLICIT_LYRICS = "露骨的歌词"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=280
  override val FACEBOOK = "Facebook"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=58
  override val FACEBOOK_AUTHENTICATION_FAILURE_MESSAGE = "無法通過Facebook驗證身份。請稍後再試。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=147
  override val FACEBOOK_COMMUNITY = "Facebook社區"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2552
  override val FAILED_PRACTICE_DOWNLOAD = "下载练习失败"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2568
  override val FAILED_PRACTICE_DOWNLOAD_EXPLANATION = "下载此练习时出了点问题。请再试一次。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1308
  override val FAMILY_SHARING_ANSWER = "很遗憾，我们不支持Apple家庭共享。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1307
  override val FAMILY_SHARING_QUESTION = "我可以和家人共享我的訂閱嗎？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1434
  override val FAQ_PAGE = "常見問題解答頁面"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=269
  override val FAVORITE = "添加到收藏夾"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=278
  override val FAVORITES = "收藏夾"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1261
  override val FEATURE_REQUEST = "功能提議"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2153
  override val FEEDBACK_OPTIONAL = "反馈（可选）"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1274
  override val FEEDBACK_SUBMITTED_TEXT = "感謝您的來信！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2553
  override val FETCHING_PRACTICE = "创建实践..."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1417
  override val FITBIT_ANSWER = "不能。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1416
  override val FITBIT_QUESTION = "APP能不能連接FitBit？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=140
  override val FORGOT_PASSWORD = "密碼忘了?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=461
  override val FORGOT_PASSWORD_NEEDS_EMAIL = "請輸入郵箱以便重置密碼。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1291
  override val FREE_FOR_HEALTHCARE_WORKERS = "醫護人員可免費使用"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1110
  override val FREE_FOR_SCHOOLS = "在校師生可免費使用"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1395
  override val GET_COMPANIES_MEMBERSHIP = "申領企業免費會員資格"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1393
  override val GET_HEALTHCARE_MEMBERSHIP = "申領醫護人員會員資格"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1392
  override val GET_STUDENT_MEMBERSHIP = "申領學生會員資格"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1463
  override val GIFT_ANSWER = "不可以，我們暫時不提供此服務。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3823
  override val GIFT_INSTRUCTIONS_CONTENT_1 = "购买您的 Down Dog 礼物（或多份礼物！）"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3824
  override val GIFT_INSTRUCTIONS_CONTENT_2 = "接收您可以打印或发送给朋友和家人的礼品券"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3825
  override val GIFT_INSTRUCTIONS_CONTENT_3 = "收件人可以使用他们证书中的二维码在准备好时开始他们的一年访问！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3780
  override val GIFT_INSTRUCTIONS_TITLE = "如何运作："
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1462
  override val GIFT_QUESTION = "我可以贈送訂閱嗎？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1440
  override val GO_TO_APPLE_SUPPORT = "前往Apple支持頁面"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1519
  override val GOAL_STREAK_CAPITALIZED = "目標連續達成次數"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1514
  override val GOAL_STREAK_NOT_CAPITALIZED = "目標連續達成次數"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=281
  override val GOOGLE = "Google"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=60
  override val GOOGLE_AUTHENTICATION_FAILURE_MESSAGE = "無法通過Google驗證身份。請稍後再試。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1401
  override val GOOGLE_FIT_ANSWER = "很遗憾，我们不再支持Google Fit。\n\nGoogle进行了一些改变，这使得我们很难继续将Google Fit集成到我们的产品中。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1400
  override val GOOGLE_FIT_QUESTION = "APP可以連接Google Fit嗎？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1495
  override val GUIDED_MEDITATION_AND_BREATHING_ANSWER = "<b>瑜伽：</b>\n\n<em>尝试瑜伽休眠</em>\n\n您可以在瑜伽应用中的练习<b>类型</b>下找到<b>瑜伽休眠</b>。\n\n注意：瑜伽休眠是<b>仅音频</b> - 不会有视频。\n\n很多人喜欢在应用中将<b>音乐</b>设置为自然声音、环境音、脑波或钢琴和弦乐。试试看哪一种你更喜欢！\n\n如果你是瑜伽休眠的新手，我们建议你将<b>指导类型</b>设置为<b>完全解释</b>或<b>默认</b>。\n\n你也可以使用瑜伽休眠来入睡。选择瑜伽休眠作为你的练习类型后，进入<b>提升</b>并点击<b>睡眠</b>！\n\n\n<b>孕期瑜伽：</b>\n\n将你的<b>提升</b>设置为<b>呼吸</b>！这将在你的练习开始时给你一些呼吸练习，以及在结束时的一次引导冥想！\n\n\n<b>冥想：</b>\n\n我们有一个完全专门用于冥想和呼吸的应用！在<a href='https://meditation.downdogapp.com/download'>冥想</a>查看！\n\n如果你是冥想的新手，为了接收我们提供的最多的指导，向上滑动设置视图并将你的<b>指导量</b>设置为<b>最多</b>，并将你的<b>最长沉默</b>设置为短时间，如30秒或1分钟。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1494
  override val GUIDED_MEDITATION_AND_BREATHING_QUESTION = "如何在練習過程中體驗更多的呼吸和冥想引導？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=95
  override val HEALTH_DISCLAIMER_AND_WARNING = "健康免責聲明及警告"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=97
  override val HEALTH_WAIVER_TEXT = "* Yoga Buddhi Co.提供僅為教育目的而設計的健康和健身信息。任何Yoga Buddhi Co.創建的APP（包含但不只限於台式電腦、手機以及其他設備上的軟件，以及任何由Yoga Buddhi Co.或下犬瑜伽APP管理的網站、博客或社交媒體網頁）中提供的信息皆不可代替專業醫療建議、診斷或治療。Yoga Buddhi Co.並不以任何形式擔保旗下APP中提供的內容完全正確、完整或實用。使用本APP或任何Yoga Buddhi Co.創建的APP中提供的信息而產生的風險由您自行承擔。我們對練習期間遭受的傷害不承擔任何責任，且Yoga Buddhi Co.不對任何旗下APP中呈現的活動或概念所直接或間接引發的損害、情景、狀態或創傷承擔法律責任。瑜伽練習自帶受傷風險。如果您懷孕或未滿18歲，我們不建議您在未經適當監督的情況下進行瑜伽練習。一旦使用Yoga Buddhi Co.出品的任意一款APP，您便為自己的身體狀態和可能對您或嬰兒的健康產生任何影響的損傷或意外自行承擔所有責任。在開始任何健身計劃之前、或如果您對個人健康狀態有任何疑慮或疑問，都請諮詢醫師或專業醫護人員。如果您的醫師或醫護人員提出反對，請勿開始健身計劃。如果運動過程中出現任何暈眩、頭暈、疼痛或呼吸急促時，您應立即停止練習並儘快就醫。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1391
  override val HEALTHCARE_FREE_UNTIL_JANUARY_1_LONG = "医疗保健提供者有资格获得免费会员资格，直至 2022 年 6 月 1 日！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1459
  override val HEALTHCARE_MEMBERSHIPS = "醫護會員制"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1753
  override val HERE_ARE_YOUR_SETTINGS = "這是您的設置！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=785
  override val HIIT = "HIIT"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=758
  override val HIIT_GOOGLE_FIT_DESCRIPTION = "間歇訓練健身"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=282
  override val HISTORY = "歷史"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1517
  override fun HOURS_SHORT(p0: Any) = "${p0}小時"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1176
  override val HOW_MANY_INTRO_LESSONS_ANSWER = "我們的入門系列共有9節課時！\n\n如果您點擊<b>類型</b>，便會看到3種分類：流瑜伽、哈達瑜伽和復元瑜伽。\n\n一旦您選擇了<b>類型</b>，即可選擇數字（<b>1、2、或3</b>）進入相應課程。以數字標明的課時按照循序漸進的學習節奏設計，所以我們建議從1開始。如果圓圈背景色為全白，即代表您已選中了這一系列的這一課時。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1168
  override val HOW_MANY_INTRO_LESSONS_QUESTION = "有多少個入門課程？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1475
  override val HOW_TO_CANCEL_ANSWER = "<b>如何管理或取消訂閱</b>\n\n<em>如果您曾通過官網購買訂閱：</em>\n\n1. 請前往<b>設置</b>界面。在移動客戶端上，請點擊屏幕右下角的三條橫線。在網頁版中，「設置」在左側欄裡。\n2. 在<b>設置</b>界面下，點擊<b>訂閱</b>。\n3. 然後您會看到更多信息，包括如何取消或更改訂閱，以及關閉自動續訂功能。\n\n<em>如果您曾通過移動客戶端購買訂閱：</em>\n\n您可以通過 <a href=\"https://support.apple.com/zh-cn/HT202039\" target=\"_blank\">Apple APP商城</a>或<a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=zh-Hans\" target=\"_blank\">Google Play商城</a>管理訂閱。\n\n<b>有關您的訂閱</b>\n\n除非您通過我們的官網、Apple或Google專門購買了訂閱，否則我們絕不會向您收取訂閱費用。您可以在購買時使用的電郵地址下查看訂閱。如果您的賬號中並未顯示訂閱，這意味著您目前登陸的電郵地址並無有效訂閱。也許您的訂閱和另一個電郵地址關聯。如果是這種情況，您需要退出登陸，然後使用該電郵地址重新登陸，才能查看您的訂閱。\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1476
  override val HOW_TO_CANCEL_QUESTION = "我想取消訂閱。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=99
  override val I_AGREE = "我同意"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1352
  override val I_HAVE_A_DIFFERENT_QUESTION = "我有其他問題"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1264
  override val I_HAVE_A_QUESTION_ABOUT = "我的提問有關："
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1383
  override val I_STILL_NEED_HELP = "我仍然需要幫助"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1387
  override val I_WANT_A_REFUND = "我想申請退款"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3292
  override val INCLUDE_POSES_ANSWER = "<b>瑜伽</b>\n\n通过我们的“喜欢和排除的体式”功能，您可以“喜欢”选择的体式，这将增加它们在未来练习中出现的概率。在您的完整设置中，点击<b>练习</b>下的<b>查看体式</b>。在这里，您可以“喜欢”您希望在练习中看到更多的体式。\n\n在<b>查看体式</b>中，您也可以“不喜欢”体式，它们将被排除在任何未来的练习之外。\n\n请注意，“喜欢和排除的体式”功能只适用于新的练习类型，如流瑜伽、恢复瑜伽、阴瑜伽、温和瑜伽和哈他瑜伽。旧的练习类型不支持此功能。\n\n还请注意，喜欢/不喜欢体式将影响多样性。\n\n<b>HIIT</b>\n\n是的！在练习下，点击<b>混合</b>。从那里，点击每个身体部位左边的+，您将看到一列练习出现。点击您想要排除的特定练习。\n\n<b>孕妇瑜伽，芭蕾</b>\n\n我们目前还没有这个功能，但它绝对在我们的列表上！现在，在移动应用程序上，您可以通过在出现时向左滑动来跳过任何您不喜欢的体式。在网络应用程序上，点击屏幕左下角的前进箭头。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3291
  override val INCLUDE_POSES_QUESTION = "我可以在我的练习中包含特定的姿势吗？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=155
  override val INSTAGRAM = "Instagram"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=61
  override val INVALID_EMAIL_MESSAGE = "這似乎不是有效的郵箱地址。請再試一次。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=161
  override val KEEP_TIMELINE_VISIBLE = "顯示時間軸"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=250
  override val LANGUAGE = "語言"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1426
  override val LATEST_PAYMENT = "您最近一次付款是："
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1396
  override val LEARN_MORE = "了解更多"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=168
  override val LENGTH = "時長"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=254
  override val LESS = "收起"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1179
  override val LEVEL_ANSWER = "每個人的狀態都不一樣，因此您可以每次嘗試提升一階，看看身體感覺如何。也許今天您想降低練習難度，明天又想嘗試新的練習！最重要的是：仔細聆聽身體為您提供的反饋，並在練習過程中緩慢移動、保持覺察。\n\n您可以通過APP中的<b>設置</b>頁面前往我們的<a href=\"https://www.facebook.com/groups/183894272193568/\" target=\"_blank\">Facebook社區</a>，遇見志同道合的APP社區同伴，獲得很好的建議。\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1171
  override val LEVEL_QUESTION = "我什麼時候可以確認升階？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=344
  override val LIFETIME = "終生"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1465
  override val LIFETIME_ANSWER = "不可以，我們暫時不提供此服務。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1464
  override val LIFETIME_QUESTION = "我可以購買終身會員制嗎？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3945
  override val LIKE = "点赞"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3047
  override val LIKE_OR_DISLIKE_EXPLANATION = "喜欢或不喜欢的姿势，以改善您的未来练习"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3199
  override fun LIKED_DISLIKED_COUNT(p0: Any, p1: Any) = "${p0} 喜欢，${p1} 不喜欢"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2030
  override val LOCK_SCREEN_MEDIA_CONTROLS = "鎖頻媒體控件"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1729
  override val LOG_IN = "登陸"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1407
  override fun LOGGED_IN_AS(p0: Any) = "您正在以${p0}的身份登陸。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=310
  override val LOGIN_ERROR = "登錄出錯"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=141
  override val LOGOUT = "退出登錄"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=62
  override val LOGOUT_NO_INTERNET_MESSAGE = "您好像沒有連接網絡。請先聯網，再切換賬戶。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1456
  override fun LOOK_SCHOOL_PAGE(p0: Any) = "如果您是學生或老師，請查看我們的${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1227
  override val LOWER_VIDEO_QUALITY_ANSWER = "如果想切換屏幕內容，請點擊<b>更多選項</b>，然後點擊<b>屏幕內容</b>。您會看到高清、標清和流暢視頻的選項。此設置只針對我們的瑜伽APP有效。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1217
  override val LOWER_VIDEO_QUALITY_QUESTION = "視頻佔用了太多手機存儲空間。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2158
  override val MAKE_SURE_TO_VOTE_FOR_EVERY_OPTION = "确保为每个选项投票！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1486
  override val MANAGE_EMAIL_PREFERENCES_ANSWER = "我們盡量避免發送過多電郵，但請知悉，電郵是我們的主要聯絡工具，能及時通知您有關特價活動和新功能上線的訊息。\n\n如果想管理您的電郵訂閱偏好，請前往<b>設置</b>，然後下滑至<b>接收推廣郵件</b>，調整開關。\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1488
  override val MANAGE_EMAIL_PREFERENCES_QUESTION = "如何管理我的電郵偏好設置？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1161
  override val MAXIMUM_VERBOSITY_ANSWER = "<b>「瑜伽」和「孕期瑜伽」：</b>\n\n如果想獲得更細緻的講解，請在設置界面中上滑，然後點擊<b>講解</b>。再點擊<b>完整解析</b>即可收聽我們最詳細的講解。\n\n<b>「冥想」</b>\n\n如果想收聽最詳細的講解，請將<b>講解細節</b>調節至<b>最多</b>，並且縮短<b>最長的寂靜</b>，比如調節至30秒或1分鐘。\n\n<b>「HIIT高強度間歇訓練」和「Barre芭蕾健身」：</b>\n\n我們目前暫不提供在「高強度間歇訓練HIIT」和「芭蕾健身Barre」中調節講解細節的選項。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1160
  override val MAXIMUM_VERBOSITY_QUESTION = "我想在練習過程中聽到最詳細的講解。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1661
  override val MEDITATION = "冥想"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1672
  override val MEDITATION_GOOGLE_FIT_DESCRIPTION = "冥想練習"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1431
  override val MEMBERSHIP_DELAYED_START_ANSWER = "不可以，訂閱在購買後便立即生效。\n\n如果您正處於免費試用期，您可以等到試用期結束後再進行購買；但在此期間如果我們提供特價優惠，您的延期也許意味著錯過最佳價格——我們知道這也許會是個困難的選擇！\n\n無論我們是否在提供特價優惠，我們的官網通常都會提供全網最低價格，所以當您準備好進行購買時，請前往<a href=\"/purchase\">downdogapp.com/purchase</a>！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1430
  override val MEMBERSHIP_DELAYED_START_QUESTION = "我可以把訂閱起始日期往後延遲嗎？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=148
  override val MENU = "菜單"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1163
  override val MINIMUM_VERBOSITY_ANSWER = "<b>瑜伽和产前瑜伽：</b>\n\n您可以通过向上滑动设置视图，然后点击<b>指导</b>来减少对话的数量。点击<b>最少</b>以接收我们提供的最少的指导。\n\n<b>冥想：</b>\n\n要接收我们提供的最少指导，向上滑动设置视图并将您的<b>指导量</b>设置为<b>最少</b>，并将您的<b>最长沉默</b>设置为更长的时间，例如5分钟或更长！\n\n<b>HIIT和巴雷：</b>\n我们目前不提供改变HIIT和巴雷的对话量的能力。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1162
  override val MINIMUM_VERBOSITY_QUESTION = "我想體驗安靜，只播放最簡約的語音講解。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=309
  override fun MINUTES(p0: Any) = "${p0}分鐘"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1254
  override fun MINUTES_SHORT(p0: Any) = "${p0}分鐘"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1610
  override val MINUTES_WITHOUT_NUMBER = "分鐘"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1554
  override val MIRROR_VIDEO = "翻轉視頻"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3
  override val MISSING_APPLE_HEALTH_PERMISSIONS_MESSAGE = "下犬瑜伽Down Dog已被列為Apple健康APP中的數據來源之一。如果想開始收錄練習，您需要首先進入健康APP，在「體能訓練」中啟用下犬瑜伽的權限。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1583
  override val MIX = "內容組合"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1510
  override val MONDAY = "週一"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=519
  override val MONTH = "月"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=377
  override val MONTHLY = "每月"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1290
  override val MONTHLY_CAPITALIZED = "月度"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1511
  override val MONTHLY_PRACTICES = "每月練習"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1516
  override fun MONTHLY_TIME(p0: Any) = "${p0}總時長"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1513
  override val MONTHLY_TIME_PRACTICED = "每月練習時長"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1482
  override val MONTHLY_TO_YEARLY_ANSWER = "如果您已經購買了月度訂閱，但想切換至年度訂閱，則需採取一些步驟，具體取決於您當前訂閱的購買方式。\n\n<em>如果您曾通過我們的<b>官網</b>或<b>Google Play商城</b>購買訂閱</em>：\n\n如果您曾通過網頁版購買了當前訂閱，請前往<b>設置</b>，然後到<b>訂閱</b>界面中取消您的當前訂閱。如果您曾通過Google Play商城購買，請前往<a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=zh-Hans\" target=\"_blank\">Google Play商城</a>取消當前訂閱。在取消當前訂閱以後，您可以<a href=\"/purchase\">通過我們的官網購買新的訂閱</a>。\n\n請留意，如果您決定取消並重新購買，我們將無法為您提供部分退款。在某些有限情況下，您也許符合條件可為當前的購買款項申請退款——請在<a href=\"/support\">客服</a>頁面選擇「我想申請退款」以查看退款申請條件。如果您確實符合條件、已成功通過<a href=\"/support\">客服</a>頁面的「我想申請退款」提交申請並獲得了退款確認，您的當前訂閱便會自動取消。然後您便可以<a href=\"/purchase\">通過我們的官網購買新的訂閱</a>。\n\n<em>如果您曾通過<b>Apple</b>購買訂閱</em>：\n\n您需要先<a href=\"https://support.apple.com/zh-cn/HT202039\" target=\"_blank\">通過Apple APP商城</a>取消訂閱。請留意，我們無法為Apple內購項目提供退款。您通過Apple取消了當前訂閱以後，便可以<a href=\"/purchase\">通過我們的官網購買新的訂閱</a>——通常官網會提供最低價格！\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1481
  override val MONTHLY_TO_YEARLY_QUESTION = "我買了月度訂閱，但想切換到年度訂閱。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=276
  override val MORE = "更多選項"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=182
  override val MUSIC = "音樂"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1140
  override val MUSIC_VOLUME_VS_VOICE_ANSWER = "開始練習後，如果點擊屏幕並暫停練習，則可以使用<b>音樂/人聲拖動條</b>來調節音樂和人聲之間的音量比例，然後再通過您的設備本身增加或減小整體音量。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1139
  override val MUSIC_VOLUME_VS_VOICE_QUESTION = "我怎麼聽不到人聲講解？怎麼調節音量？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=400
  override val MY_DATA = "我的數據"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=429
  override val NEED_INTERNET_FOR_SONG_PREVIEW_MESSAGE = "誒，您需要連接網絡才能試聽音樂。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3587
  override val NEW_PASSWORD = "新密码"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=9
  override val NEXT = "下一個"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=403
  override val NEXT_PAYMENT = "下次付款"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=483
  override fun NEXT_PAYMENT_SUBTEXT(p0: Any) = "下次付款到期日：${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1499
  override val NIDRA_AUDIO_ONLY_ANSWER = "<b>瑜伽尼達拉僅提供音頻</b>——並不會播放視頻！\n\n瑜伽尼達拉是引導您深度放鬆的冥想。請在練習<b>類型</b>頁面中一直下滑到最底部，即可點擊選擇。許多人喜歡將APP的<b>音樂</b>設置為「自然聲」、「氛圍」、「腦電波」或「鋼琴和弦樂」……請按照您的喜好嘗試，找到最喜歡的搭配。\n\n如果您不熟悉瑜伽尼達拉，我們建議您在聆聽時將<b>講解類型</b>設為<b>完整解析</b>或<b>默認</b>。您也可以使用瑜伽尼達拉幫助您入睡。\n\n選擇瑜伽尼達拉作為練習類型後，前往<b>側重點</b>然後點擊<b>助眠</b>！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1498
  override val NIDRA_AUDIO_ONLY_QUESTION = "我的瑜伽尼達拉練習沒有視頻。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1472
  override val NO_EXCHANGE_FEES_ANSWER = "我們不收取任何匯兌費或轉換費，但您的銀行也許會因為外匯而扣款，因此請與他們確認。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1471
  override val NO_EXCHANGE_FEES_QUESTION = "你們是否收取匯兌費？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=160
  override val NO_FACEBOOK_EMAIL_MESSAGE = "請允許訪問您的郵箱地址以便通過Facebook登錄。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=162
  override val NO_HISTORY_TEXT = "您好像還沒有完成任何練習。請側滑返回主屏幕，進入您的第1次練習！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=63
  override val NO_INTERNET_MESSAGE = "與服務器溝通時遇到問題。請確保您已連接網絡，然後重試。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1497
  override val NO_MUSIC_OFFLINE_ANSWER = "由於版權限制，我們無法在您離線使用緩存練習的時候為您播放音樂。\n\n您可以通過手機或平板上的其他APP播放自己的音樂。不過即便Down Dog人聲講解已默認被調到最大音量，有時依然無法蓋過來自Spotify或iTunes等音樂軟件的聲音。\n\n面對這類情況，我們建議您使用外接音箱播放音樂，或者用筆記本電腦或台式電腦使用網頁版<a href=\"/web\">downdogapp.com/web</a>，隨後自行調低背景音樂音量。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1496
  override val NO_MUSIC_OFFLINE_QUESTION = "處於離線狀態時，我緩存過的收藏夾練習沒有包含音樂。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2551
  override val NO_OFFLINE_PRACTICES = "您还没有下载任何练习。您可以从您的历史记录中下载练习，或在此处创建一个新练习！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1478
  override val NO_PARTIAL_REFUND_ANSWER = "很遺憾，我們無法提供部分退款或按比例退款。\n\n如果您已購買了訂閱，但希望能轉向另一個訂閱方案，則需採取一些步驟，具體取決於您當前訂閱的購買方式。\n\n<em>如果您曾通過我們的<b>官網</b>或<b>Google Play商城</b>購買訂閱</em>：\n\n如果您曾通過網頁版購買了當前訂閱，請前往<b>設置</b>，然後到<b>訂閱</b>界面中取消您的當前訂閱。如果您曾通過Google Play商城購買，請前往<a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=zh-Hans\" target=\"_blank\">Google Play商城</a>取消當前訂閱。在取消當前訂閱以後，您可以<a href=\"/purchase\">通過我們的官網購買新的訂閱</a>。\n\n請留意，如果您決定取消並重新購買，我們將無法為您提供部分退款。在某些有限情況下，您也許符合條件可為當前的購買款項申請退款——請在<a href=\"/support\">客服</a>頁面選擇「我想申請退款」以查看退款申請條件。如果您確實符合條件、已成功通過<a href=\"/support\">客服</a>頁面的「我想申請退款」提交申請並獲得了退款確認，您的當前訂閱便會自動取消。然後您便可以<a href=\"/purchase\">通過我們的官網購買新的訂閱</a>。\n\n<em>如果您曾通過<b>Apple</b>購買訂閱</em>：\n\n您需要先<a href=\"https://support.apple.com/zh-cn/HT202039\" target=\"_blank\">通過Apple APP商城</a>取消訂閱。請留意，我們無法為Apple內購項目提供退款。您通過Apple取消了當前訂閱以後，便可以<a href=\"/purchase\">通過我們的官網購買新的訂閱</a>——通常官網會提供最低價格！\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1477
  override val NO_PARTIAL_REFUND_QUESTION = "我能申領部分退款嗎？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=283
  override val NO_PAST_PURCHASES = "無購買記錄"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=163
  override val NO_PAST_PURCHASES_MESSAGE = "您好像沒有任何購買歷史。如果此信息有誤，請聯繫我們。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1454
  override val NO_REFUND_PRACTICED = "由於您在購買後已使用APP完成練習，因此這筆款項無法退款。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1455
  override fun NO_REFUND_TIME(p0: Any) = "這筆款項發生在${p0}天前，因此無法退款。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=164
  override val NO_SAVED_PRACTICES_TEXT = "保存最喜歡的練習，以便稍後重播。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1224
  override val NO_SOUND_ANSWER = "您可以試試以下步驟讓APP發出聲音：\n\n• 您是否已確保設備本身並未靜音？您可以通過其他APP播放音樂或音頻來檢查此設定。\n• 您是否已打開APP內的音量？如果想調節音樂和人聲之間的音量比例，您可以在開始練習後點擊屏幕以暫停練習，然後調整屏幕最下方的<b>音樂/人聲拖動條</b>。如果想同時聽到音樂和人聲，請確保您調節至中間點！\n• 您是否已嘗試關閉再重啟此APP？\n• 您是否已嘗試卸載然後重新安裝此APP？\n• 您可以試試Down Dog網頁版（<a href=\"https://www.downdogapp.com/web\" target=\"_blank\">https://www.downdogapp.com/web</a>）看看是否有出現同樣的問題？\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1214
  override val NO_SOUND_QUESTION = "我聽不到聲音。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=10
  override val NO_STRING = "否"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1388
  override val NO_SUBSCRIPTIONS_SUPPORT_MESSAGE = "您的賬號中目前並無有效的訂閱。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=284
  override val NONE = "無"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1483
  override val NOT_FREE_ANSWER = "在2018年9月，我们转向了一种新的定价模式，我们为用户提供一个简短的免费试用期，期间可以完全访问所有功能，之后需要订阅。此定价模式适用于我们所有的应用程序。\n\n<b>购买方式</b>\n\n<a href=\"/purchase\">通过我们的网站购买</a>通常可以获得最优惠的价格！您可以使用<b>信用卡</b>或<b>PayPal</b>在我们的网站上购买。通过我们的网站购买可以让您访问所有应用程序中的所有内容，就像通过Apple或Google应用内购买一样。\n\n您也可以通过Apple或Google进行应用内购买。请注意，Apple和Google会收取佣金费用，这就是为什么应用内价格通常会高于我们网站上的价格。\n\n对于在美国以外地区的购买，我们不收取任何兑换费用，但您的银行可能会收取，因此请务必与他们确认！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1468
  override val NOT_FREE_QUESTION = "我以為APP是免費的，為什麼會被要求購買訂閱？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=285
  override val OK = "確認"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1686
  override fun ONLY_MIX_GROUP(p0: Any) = "只練${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=243
  override val OPEN_IN_AMAZON = "在亞馬遜上打開"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=216
  override val OPEN_IN_ITUNES = "在iTunes中打開"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=32
  override val OPEN_IN_SPOTIFY = "在Spotify中打開"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1257
  override fun OPEN_IN_X(p0: Any) = "通過${p0}打開"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3948
  override val OPEN_LINK = "打开链接"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2149
  override fun OPTION_X_OF_Y(p0: Any, p1: Any) = "${p1} 的选项 ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=142
  override val OR = "或"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1111
  override val OTHER = "其他"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1059
  override val OTHER_APPS = "其他APP"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=194
  override val PACE = "速度"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=463
  override val PASSWORD = "密碼"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=68
  override val PASSWORD_LENGTH_MESSAGE = "您的密碼必須至少包含4個字符。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=445
  override val PASSWORDS_MUST_MATCH = "密碼必須一致"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3944
  override val PAUSE = "暂停"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=339
  override val PAY_WITH = "支付"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=349
  override val PAY_WITH_PAYPAL = "PayPal支付"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=480
  override val PAYPAL = "PayPal"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=347
  override val PAYPAL_AUTHORIZATION_ERROR_MESSAGE = "PayPal授權購買出錯。請稍後重試，或聯繫客服。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1419
  override val PAYMENT_ALREADY_REFUNDED = "這筆款項已經退還。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=165
  override val PAYMENT_CONFIRMED_MESSAGE = "付款確認成功！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1474
  override val PAYMENT_METHODS_ANSWER = "您可以通过以下方式购买订阅！\n\n1) 您可以通过我们的网站使用 <b>信用卡</b> 或 <b>PayPal</b> 进行购买。\n\n通过我们的网站购买，您可以访问所有应用程序中的所有内容，就像您通过 Apple 或 Google 购买应用程序内一样。我们网站上的价格通常是最优惠的价格，因为不涉及 Apple/Google 佣金。\n\n2) 您可以通过 Apple 或 Google 进行应用内购买。\n\n请注意，Apple 和 Google 会收取佣金，这就是为什么应用内价格通常会高于我们网站上的价格。\n\n对于在美国境外购买的商品，我们不收取任何兑换费，但您的银行可能会收取，因此请务必与他们核实！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1473
  override val PAYMENT_METHODS_QUESTION = "有哪些支付方式可供使用？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=465
  override val PAYMENT_PLAN = "付款計劃"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=317
  override val PER_MONTH = "每月"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=318
  override val PER_YEAR = "每年"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2539
  override val PILATES = "普拉提"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2549
  override val PILATES_GOOGLE_FIT_DESCRIPTION = "普拉提锻炼"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3943
  override val PLAY = "播放"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=55
  override val PLAY_STORE_PRODUCT_PRICES_MESSAGE = "從Play商城獲取產品價格時出錯"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=319
  override val PLAYLIST = "播放列表"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=72
  override val PLAYLIST_TYPE_BUSY = "更改播放列表類型時出錯。請稍等幾秒再試。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=73
  override val PLAYLIST_TYPE_NO_INTERNET_MESSAGE = "您好像沒有連接網絡。請重新聯網，再更改音樂風格。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3049
  override fun POSE_DISLIKED_MESSAGE(p0: Any) = "我们将在您未来的练习中排除${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1199
  override val POSE_LIBRARY_ANSWER = "我們目前尚未提供體式全圖典，但已經開始製作。敬請關注！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1188
  override val POSE_LIBRARY_QUESTION = "是否能提供「體式全圖典」，讓我能詳細了解每一個體式？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3048
  override fun POSE_LIKED_MESSAGE(p0: Any) = "我们将在您未来的练习中增加更多的${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1532
  override val POSE_LIST = "體式列表"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3008
  override val POSE_LIST_DESCRIPTION = "探索下面的所有姿势，并指定您在未来的练习中希望看到更多或更少的姿势。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3252
  override val POSE_NAMES = "体式名称"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3071
  override val POSES = "体式"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=286
  override val PRACTICE = "練習"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1275
  override val PRACTICE_FEEDBACK = "練習反饋"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=166
  override val PRACTICE_SAVED_CONFIRMATION = "練習已添加到收藏夾！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1515
  override val PRACTICE_STREAK_NOT_CAPITALIZED = "連續練習次數"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1293
  override fun PRACTICES_IN_MONTH(p0: Any) = "${p0}練習"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=456
  override val PRENATAL = "孕期瑜伽"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1200
  override val PRENATAL_ANSWER = "有的——我們現已出品一款獨立的孕期瑜伽APP！歡迎您體驗「孕期瑜伽」<a href=\"https://play.google.com/store/apps/details?id=com.downdogapp.prenatal\" target=\"_blank\">安卓版</a>、<a href=\"https://apps.apple.com/us/app/prenatal-yoga-down-dog/id1504152442\" target=\"_blank\">iOS版</a>或網頁版<a href=\"https://prenatal.downdogapp.com/web\" target=\"_blank\">prenatal.downdogapp.com/web</a>。這款APP可以讓您根據自己的孕期階段量身定制練習。它保留了原本Down Dog下犬瑜伽APP裡的許多側重點選項，但同時也提供幾款孕期專用特殊側重點。\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1189
  override val PRENATAL_QUESTION = "我懷孕啦！有沒有適合孕期的選項？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1267
  override val PRENATAL_SHORT = "孕期瑜伽"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2554
  override fun PREPARING_VIDEO_PROGRESS(p0: Any) = "正在准备视频...完成 ${p0}%"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2569
  override val PREPARING_VIDEO_WARNING = "我们正在准备您的视频。请保持应用程序打开，直到下载开始或在几分钟后返回应用程序以开始下载。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1405
  override val PRICE_DIFFERENCE_ANSWER = "<a href=\"/purchase\">通過我們的官網購買訂閱</a>即可避開Apple或Google的內購手續費，因此官網上的價格通常最為實惠！您可以使用<b>信用卡</b>或<b>PayPal</b>在官網上購買。通過官網購買即可為您解鎖Down Dog全系列APP內容，和Apple或Google內購的內容一樣。網頁上購買的訂閱也可以在電腦、手機或平板上使用。\n\n您也可以通過Apple或Google進行APP內購。請留意，Apple和Google都會收取手續費，因此內購價格通常會比官網價格要高。\n\n*面對美國境外的顧客，我們不收取任何匯兌費，但您的銀行也許會因外匯而扣款，因此請與銀行客服進行確認。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1404
  override val PRICE_DIFFERENCE_QUESTION = "為什麼APP內的價格和網頁版不同？這些會員資格性質不一樣嗎？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=287
  override val PRIVACY_POLICY = "隱私政策"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=398
  override val PROMOTIONAL_EMAILS = "接收推廣郵件"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=351
  override fun RECEIPT_SENT_TO_EMAIL_MESSAGE(p0: Any) = "收據將發送至${p0}。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1461
  override val RECEIPTS_ANSWER = "購買訂閱後，我們會把收據發送到與您的訂閱相關聯的電郵地址。\n\n很遺憾，收據無法被重複發送。如果您需要查找原始收據，我們建議您在郵箱中搜索郵件主題<b>「您的Down Dog收據」</b>。請確保您也查看了郵件垃圾箱。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1460
  override val RECEIPTS_QUESTION = "可以把購買訂閱的收據發給我嗎？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3799
  override val REDEEM = "兑换"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3798
  override fun REDEEM_GIFT_INSTRUCTIONS(p0: Any, p1: Any) = "点击下面的按钮领取一年的免费 Down Dog 访问权限！礼品（代码 ${p0}）将在您兑换礼品的当天记入您的账户 ${p1}。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3797
  override val REDEEM_GIFT_VIEW_TITLE = "兑换您的 Down Dog 礼品卡"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1222
  override val REFUND_ANSWER = "如果您通過網頁版購買了訂閱，請通過我們的<a href=\"/support\">客服</a>頁面申請退款。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1212
  override val REFUND_QUESTION = "如何申請退款？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1424
  override val REFUNDED_ON_WAY = "您的退款很快就會到賬。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=626
  override val REMOVE_FROM_FAVORITES = "從收藏夾中刪除"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=625
  override val REMOVE_FROM_HISTORY = "從歷史中刪除"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=663
  override val REMOVE_FROM_HISTORY_MESSAGE = "您確定要從歷史記錄中刪除此練習嗎？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1206
  override val RENAME_FAVORITES_ANSWER = "可以！請前往<b>收藏夾</b>界面，點擊<b>編輯名稱</b>，即可按您的喜好更改練習名稱！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1194
  override val RENAME_FAVORITES_QUESTION = "我能不能重新命名收藏夾裡的練習，更方便分辨？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3421
  override fun REQUIRED_EMAIL_DOMAIN_ALERT(p0: Any) = "请使用带有 ${p0} 域名的电子邮件地址登录！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1910
  override val RESET = "重置"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=154
  override fun RESET_PASSWORD_MESSAGE(p0: Any) = "重置密碼的鏈接已發送至：${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=167
  override val RESUME_PRACTICE = "回到練習"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=169
  override val RESUME_PRACTICE_MESSAGE = "是否恢復之前的練習？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2245
  override val RUNNING = "跑步"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2255
  override val RUNNING_GOOGLE_FIT_DESCRIPTION = "下犬式跑步训练"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=66
  override val SAFARI_OR_MOBILE_BROWSER_WARNING_MESSAGE = "手機和平板用戶請從APP商店或Play商城下載此APP以獲得最佳體驗。台式或筆記本電腦用戶請使用Chrome瀏覽器以獲得最穩定的播放效果。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1480
  override val SALE_PRICE_ANSWER = "每当我们有销售时，您必须通过我们的网站购买才能获得折扣价。\n\n可以使用信用卡或 PayPal 在我们的网站上进行购买。对于国际交易，我们不收取兑换费，但您的银行可能会收取，因此请务必与他们核实！\n\n如果您已经购买了订阅，并且想利用我们的特价促销，您将需要采取一些步骤，具体取决于您当前购买的方式。请注意，订阅购买在购买后立即生效，并将取消任何当前订阅。它不会添加到您当前订阅的末尾。\n\n<em>如果您通过我们的<b>网站</b>或<b>Google Play</b></em>购买：\n\n如果您通过网络购买了当前订阅，请转到<b>设置</b>，然后转到<b>订阅</b>以取消您当前的订阅。如果您通过 Google Play 购买，您可以通过 <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank 取消当前订阅\">Google Play 商店</a>。取消当前订阅后，您可以通过我们的网站购买新订阅。\n\n请注意，如果您选择取消并重新购买，我们将无法为您提供部分退款。在某些有限的情况下，您可能有资格获得当前购买的退款 - 您可以通过在<a href=\"/support\">支持</a>上单击“我要退款”来检查您的退款资格。如果您有资格获得退款，并且已在 <a href=\"/support\">支持</a> 的“我想要退款”中成功申请并收到退款确认，那么您当前的订阅将自动取消。然后您可以通过我们的网站购买新订阅。\n\n<em>如果您通过 <b>Apple</b></em> 购买订阅：\n\n您需要<a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">通过 Apple App Store</a> 取消订阅。请注意，我们无法满足通过 Apple 购买的退款请求。在您通过 Apple 取消当前订阅后，您可以通过我们的网站购买新订阅，通常价格最优惠！\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1479
  override val SALE_PRICE_QUESTION = "我收到了有關促銷活動的電郵！怎樣才能以促銷價格購買？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=198
  override val SANSKRIT_POSE_NAMES = "梵文體式名稱"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=454
  override val SAVE = "保存"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=529
  override val SAVE_AND_UNLINK = "保存並取消關聯"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1204
  override val SAVE_FOR_OFFLINE_ANSWER = "可以！目前有三種離線緩存練習的方法。請留意，以下的指南僅適用於移動客戶端，並不適用於網頁版。\n\n1. 在<b>收藏夾</b>界面中創建並緩存練習。首先，請點擊起始頁面下方的心形圖標，來到<b>收藏夾</b>界面，就會看見藍色大按鈕<b>下載新的練習</b>。點擊此按鈕，便會自動開始下載由目前設置（可在一開始的首頁查看細節）輸出的練習。請確保練習名稱右側顯示出一個朝下的箭頭，說明此練習已被緩存至您的設備。\n\n2. 在<b>歷史</b>界面中緩存練習。首先，請前往<b>歷史</b>界面（點擊起始頁面下方的時鐘圖標）。往下滑，查找並點擊您想緩存的練習。您會看到屏幕底部出現<b>添加到收藏夾</b>的字樣。點擊即可將練習保存至<b>收藏夾</b>，可供離線使用（您可以點擊屏幕下方的心形圖標以確認練習已被保存至<b>收藏夾</b>）。請確保練習名稱右側顯示出一個朝下的箭頭，說明此練習已被緩存至您的設備。\n\n3. 練習結束後，點擊<b>添加到收藏夾</b>，即可將此練習添加至<b>收藏夾</b>界面（頁面下方的心形圖標）。請確保練習名稱右側顯示出一個朝下的箭頭，說明此練習已被緩存至您的設備。\n\n請留意，由於版權限制，我們無法在您離線使用緩存練習的時候為您播放音樂。\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1192
  override val SAVE_FOR_OFFLINE_QUESTION = "我可以離線使用Down Dog嗎？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1205
  override val SAVE_TO_FAVORITES_ANSWER = "是的！\n\n<em>保存您刚完成的练习</em>\n\n如果您想在完成练习后立即保存，点击练习后页面上的<b>添加到收藏夹</b>，它将被保存到您的<b>收藏夹</b>并在您的练习中添加一个心形图标。要访问您的<b>收藏夹</b>，从<b>历史记录</b>页面（通过主屏幕底部的时钟图标访问），您可以点击历史记录中带有心形图标的任何练习，或者从<b>全部</b>切换到只看您的<b>收藏夹</b>。\n\n<em>从您的历史记录中保存以前的练习</em>\n\n如果您想保存以前做过的练习，转到您的<b>历史记录</b>页面（点击主屏幕底部的时钟图标）。一旦您到达那里，向下滚动，然后点击您想要保存的练习。您会在底部看到<b>添加到收藏夹</b>的字样。按下那个将会把练习保存到您的<b>收藏夹</b>并在您的练习中添加一个心形图标。要访问您的<b>收藏夹</b>，从<b>历史记录</b>页面，您可以点击历史记录中带有心形图标的任何练习，或者从<b>全部</b>切换到只看您的<b>收藏夹</b>。\n\n<em>有趣的事实！</em>\n\n您可以为历史记录中找到的任何练习添加标签（无论它是否是您的收藏）。只需在历史记录中点击一个练习，然后选择<b>编辑名称</b>。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1193
  override val SAVE_TO_FAVORITES_QUESTION = "能不能把我最喜歡的練習保存下來？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1458
  override val SCHOOL_MEMBERSHIPS = "校園會員制"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2150
  override val SCORE = "分数"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2151
  override val SCORE_HATE_IT = "1（讨厌）"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2152
  override val SCORE_LOVE_IT = "5（喜欢）"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3951
  override val SEARCH = "搜索"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3108
  override val SEARCH_FOR_A_POSE = "搜索一个姿势"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3286
  override val SEARCH_FOR_AN_EXERCISE = "搜索一个锻炼"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1601
  override val SEE_EXERCISES_ON_TIMELINE = "在時間軸上查看練習名稱"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1587
  override val SEE_POSES_ON_TIMELINE = "在時間軸上查看體式"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=270
  override val SELECT = "選定"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=585
  override val SEND = "發送"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=149
  override val SEND_FEEDBACK = "發送反饋"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1406
  override val SENDING_FEEDBACK_FAILED = "反饋發送失敗"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2747
  override val SEQUENCE_LENGTH_INVALID = "抱歉，您当前的设置无法达到该练习时长。请选择其他长度。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=297
  override val SET_PASSWORD = "設置密碼"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=430
  override val SETTINGS = "設置"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1177
  override val SETTINGS_FOR_BEGINNERS_ANSWER = "<b>瑜伽：</b>\n\n<em>设定你的级别</em>\n\n如果你是瑜伽新手，我们建议从<b>初级1</b>开始，可以在练习设置中找到。\n\n<em>选择你的练习类型</em>\n\n如果你想要一个包括站立姿势和地板姿势的柔和练习，试试<b>温和</b>练习类型。\n\n如果你想要一个只有地板姿势的休息练习，试试<b>恢复</b>或<b>阴瑜伽</b>，这将允许你在姿势中保持最长的时间。\n\n如果你想要一个更快、更流畅、更有活力的练习，试试<b>流瑜伽</b>。\n\n如果你想要流动性较小，跳过chaturangas，通过保持姿势更长时间来积累热量，试试<b>哈他瑜伽</b>。\n\n<em>指导级别</em>\n\n将你的<b>指导</b>级别设定为<b>完全</b>，以获得最详细的指导。\n\n<em>设定你的过渡速度和保持长度</em>\n\n如果你想进一步放慢你的练习，我们建议将你的<b>过渡速度</b>调整为<b>最慢</b>，并将你的<b>保持长度</b>调整为<b>最长</b>。请注意，旧的练习类型不支持这些功能。\n\n<em>延长你的热身和冷却时间</em>\n\n对于流瑜伽、哈他瑜伽和温和瑜伽的练习类型，将你的<b>热身</b>和<b>冷却</b>调整为<b>延长</b>。请注意，旧的练习类型不支持这些功能。\n\n<em>喜欢和排除姿势</em>\n对于流瑜伽、哈他瑜伽和温和瑜伽的练习类型，\"喜欢\"姿势并在你的练习中更常见，或者\"不喜欢\"姿势，你将再也不会看到它们。\n\n<b>孕妇瑜伽：</b>\n\n如果你是瑜伽新手，我们建议从<b>初级1</b>开始，可以通过在设置视图中向上滑动并查看练习设置找到。\n\n对于一个休息的练习，我们建议从<b>恢复</b>开始，这是所有的地板工作，并将允许在姿势中保持最长的时间。\n\n<b>冥想：</b>\n\n如果你是冥想新手，我们建议将你的<b>最长沉默</b>时间设定得相当短 - 默认是2分钟，但你可以将它缩短到30秒，如果你更喜欢少一些沉默和更多的指导。你也可以将你的<b>指导量</b>设定为<b>最多</b>，以获得我们提供的最多的指导！\n\n<b>HIIT</b>\n\n我们的默认设置是一个很好的开始！\n\n如果HIIT在1级上太有挑战性，试试0级！你也可以尝试在每个练习上花费更短的时间。你可以通过在设置视图中向上滑动并在练习下调整你的设置来调整你的练习长度。你会惊讶于5或10秒能带来多大的差异！你也可以减少你的整体锻炼时间，并增加每次恢复之间的长度。\n\n我们提供两种练习类型，<b>轮换</b>和<b>进阶</b>。选择<b>进阶</b>以按照相同的顺序移动身体的不同部位，或选择<b>轮换</b>以在不同的练习中混合身体的不同部位的顺序！\n\n<b>芭蕾：</b>\n\n你可以通过改变你的锻炼长度来调整难度。有经验的运动员应该从15或20分钟开始，如果他们想要额外的挑战，可以逐渐增加。如果你是初学者，你可能想要每天开始只有5分钟或者每隔一天10分钟。坚持下去，你将很快准备好进行更长时间的锻炼！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1169
  override val SETTINGS_FOR_BEGINNERS_QUESTION = "我該從哪兒開始練習？怎樣選擇設置才會有最佳體驗？\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1061
  override val SEVEN_MINUTE = "7分鐘健身"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=150
  override val SHARE = "分享"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1246
  override val SHARE_PRACTICE_ANSWER = "您可以在完成練習之後，從<b>歷史</b>或<b>收藏夾</b>中點擊<b>分享此練習</b>以獲取共享鏈接。\n\n當您的朋友點擊這條鏈接，就會被導向APP，並且收到「是否將此練習添加至收藏夾？」的彈出消息。他們即可點擊<b>是</b>，以確保此練習被保存至<b>收藏夾</b>！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1245
  override val SHARE_PRACTICE_QUESTION = "如何與朋友們分享練習？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1181
  override val SHARE_THIS_PRACTICE = "分享此練習"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1235
  override val SHARED_PRACTICE = "共享練習"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3257
  override val SHOW_EXERCISE_NAMES = "显示锻炼名称"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3343
  override val SHOW_LIKE_AND_EXCLUDE_BUTTONS = "显示“喜欢”和“排除”按钮"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2085
  override val SHOW_OVERLAY = "顯示「下一個」提示"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2082
  override val SHOW_POSE_NAME = "顯示體式名稱"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1555
  override val SHOW_SUBTITLES = "顯示字幕"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1728
  override val SIGN_UP = "註冊"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=64
  override val SIGN_UP_LOGIN = "註冊/登錄"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=271
  override val SKIP = "跳過"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1173
  override val SLOWER_PACE_ANSWER = "<b>瑜伽：</b>\n\n有一些设置可以调整以放慢你的练习速度 - 我们建议你尝试所有的设置！\n\n<em>过渡速度</em>\n\n向上滑动以查看你的全部设置。在<b>计时</b>下，点击<b>过渡速度</b>并将其设置为<b>最慢</b>，以便在一个姿势和另一个姿势之间过渡的时间最长，然后点击<b>选择</b>。请注意，旧的练习类型不支持此功能。\n\n<em>保持长度</em>\n\n向上滑动以查看你的全部设置。在<b>计时</b>下，点击<b>保持长度</b>并将其设置为<b>最长</b>，以便在每个姿势中保持最长时间，然后点击<b>选择</b>。请注意，旧的练习类型不支持此功能。\n\n<em>热身</em>和<em>冷却</em>\n\n将你的<b>热身</b>和<b>冷却</b>设置为<b>延长</b>。请注意，旧的练习类型不支持这些功能。\n\n<em>指导级别</em>\n\n为了获得最多的指导和提示，你也可以将你的<b>指导</b>级别设置为<b>完全</b>。\n\n<em>练习类型</em>\n\n你也可以尝试将你的练习<b>类型</b>设置为<b>温和</b>或<b>哈他</b>，而不是<b>流瑜伽</b>，以避免流瑜伽的流动/查图兰伽。或者，如果你想进一步放慢速度，可以将你的练习<b>类型</b>设置为<b>阴瑜伽</b>或<b>恢复瑜伽</b>！\n\n<b>孕妇瑜伽：</b>\n\n在设置视图中向上滑动并将你的<b>节奏</b>设置为<b>最慢</b>，以便在每个姿势中花费最多的时间。为了获得最多的指导和提示，你也可以将你的<b>指导</b>级别设置为<b>完全解释</b>。\n\n<b>HIIT：</b>\n\n你可以改变每个练习的时间。在设置视图中向上滑动并在<b>练习</b>下，点击<b>练习长度</b>。你也可以通过点击<b>恢复</b>来调整每个练习之间的休息时间。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1165
  override val SLOWER_PACE_QUESTION = "如何漸慢練習速度？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=466
  override val SOCIAL = "社交"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2086
  override val SOMETHING_WENT_WRONG = "頁面出錯"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1533
  override val SONG_LIST = "音樂列表"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=288
  override val SONGS_PLAYED = "已播放歌曲"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=272
  override val START = "開始"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1600
  override val START_PRACTICE = "開始練習"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=89
  override val START_PRACTICE_NO_INTERNET_MESSAGE = "您好像沒有連接網絡。請重新聯網，再開始新的練習。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2090
  override val START_SHARED_PRACTICE = "您要开始这种共享做法吗？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1507
  override val STAT_TYPE_SUBTITLE = "您想查看什麼內容？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1506
  override val STAT_TYPE_TITLE = "選擇查看數值"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1390
  override val STUDENTS_FREE_UNTIL_JANUARY_1_LONG = "学生和教师有资格获得免费会员资格！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1268
  override val SUBJECT_COLON = "主題："
  
  // https://worker.downdogapp.com/debug/appString?appStringId=273
  override val SUBMIT = "提交"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1266
  override val SUBMITTING = "提交中……"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=477
  override val SUBSCRIPTION = "訂閱"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1223
  override val SUBSCRIPTION_RENEWAL_PRICE_ANSWER = "會的！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1213
  override val SUBSCRIPTION_RENEWAL_PRICE_QUESTION = "我的訂閱會以購買時的價格續訂嗎？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1389
  override fun SUBSCRIPTIONS_SUPPORT_MESSAGE(p0: Any) = "您正在以${p0}的身份登陸。以下是您賬戶名下的訂閱："
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1288
  override val SUBTITLES_ANSWER = "我們提供的每種語言都包含標準字幕和隱藏式字幕！\n\n移動客戶端：\n1. 開始練習\n2. 點擊屏幕，選擇齒輪圖標。然後，將「顯示字幕」調節至開啟狀態。\n\n網頁版：\n1. 開始練習\n2. 點擊屏幕右下角的<b>cc</b>圖標即可顯示字幕\n\n如果需要關閉字幕，只需再次點擊<b>cc</b>圖標即可。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1287
  override val SUBTITLES_QUESTION = "你們是否提供標準字幕或隱藏式字幕？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=452
  override val SUCCESS = "成功"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1509
  override val SUNDAY = "週日"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=500
  override val SUPPORT = "客服"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2333
  override val SUPPORT_MANAGE_EXPECTATIONS_TEXT = "我们是一家非常小的公司，每天会收到数千条消息，因此我们无法承诺回复，但我们会尽最大努力及时回复您！请注意，我们优先考虑来自付费客户的消息。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1754
  override val SWIPE_DOWN_TO_START_PRACTICING = "向下滑動即可開始練習"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=262
  override val TAP_TO_BEGIN = "點擊開始"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1260
  override val TECH_ISSUES = "技術問題"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=289
  override val TERMS_OF_USE = "使用條款"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=303
  override val THANKS = "謝謝"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2157
  override val THANKS_FOR_FILLING_OUT_THE_SURVEY = "感谢您填写调查问卷！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1265
  override val THIS_FORM_FIELD_IS_REQUIRED = "請在此處填寫"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=615
  override val TIMELINE = "時間軸"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2050
  override val TOGGLE_SHOW_MORE_SETTINGS = "切換顯示更多設置"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2590
  override val TOO_MANY_DOWNLOADS = "您已达到同时下载的最大数量。请等待一个完成，然后重试。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1248
  override val TOTAL_PRACTICES = "練習總次數"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1523
  override val TOTAL_PRACTICES_CAPITALIZED = "總練習次數"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1524
  override val TOTAL_PRACTICES_NOT_CAPITALIZED = "總練習次數"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1252
  override val TOTAL_TIME = "總時長"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1521
  override val TOTAL_TIME_CAPITALIZED = "總時長"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1522
  override val TOTAL_TIME_NOT_CAPITALIZED = "總練習時長"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1137
  override val TROUBLESHOOTING = "疑难解答"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=251
  override val TRY_AGAIN = "重試"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1155
  override val TURN_OFF_MUSIC_ANSWER = "如果想關閉APP內的音樂，請在設置界面中上滑，選擇音樂，然後在音樂風格中選擇<b>無</b>。\n\n如果您想播放自己的音樂， 可以通過設備上的其他APP播放。但雖然人聲講解在手機和平板上已被默認調到最大音量，有時也依然不足以蓋過來自Spotify和iTunes等音樂軟件的聲音。\n\n如果您遇到了這樣的情況，我們建議您使用外接音箱來播放音樂，或者通過筆記本電腦或台式電腦使用APP網頁版（https://www.downdogapp.com/web），這樣即可自行調低背景音樂音量。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1154
  override val TURN_OFF_MUSIC_QUESTION = "我想在練習時聽我自己的音樂。如何完全關閉APP中的背景音樂？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2088
  override val UNABLE_TO_LOAD_PLAYBACK_URL = "誒，我們無法加載視頻"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1276
  override val UNABLE_TO_OPEN_LINKED_PRACTICE = "此練習和本賬號並無關聯"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=998
  override val UNKNOWN_CAST_RECEIVER_NAME = "未知設備"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1641
  override val UNLINK_FROM_APPLE = "解除Apple賬號關聯"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1642
  override val UNLINK_FROM_APPLE_MESSAGE = "設置密碼以解除與Apple的賬號關聯。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=504
  override val UNLINK_FROM_FACEBOOK = "解除Facebook賬號關聯"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=506
  override val UNLINK_FROM_FACEBOOK_MESSAGE = "設置密碼以解除與Facebook的賬號關聯。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=505
  override val UNLINK_FROM_GOOGLE = "解除Google賬號關聯"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=507
  override val UNLINK_FROM_GOOGLE_MESSAGE = "設置密碼以解除與Google的賬號關聯。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1398
  override val UNLINK_GOOGLE_FACEBOOK_ANSWER = "1. 請前往<b>設置</b>。在移動客戶端上，點擊屏幕右下角的三條橫線。在網頁版中，從左側欄中選擇設置。\n\n2. 在<b>賬戶</b>頁面下，選擇<b>解除Google賬號關聯</b>（或<b>解除Facebook賬號關聯</b>），並在「密碼」與「確認密碼」欄中填寫您想要使用的新密碼。\n\n3. 點擊<b>保存</b>。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1397
  override val UNLINK_GOOGLE_FACEBOOK_QUESTION = "如何取消與Google或Facebook的賬號關聯，只用郵箱和密碼登陸？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=418
  override val UPDATE = "更新"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1226
  override val VIDEO_ACCIDENTALLY_MIRRORED_ANSWER = "如果整個練習的動作都與講解相反，請確保您的視頻沒有在「翻轉」狀態！請按照以下指南查看：\n\n移動客戶端：\n1. 開始練習\n2. 在屏幕右上角，點擊<b>右數第二個圖標</b>以翻轉視頻\n\n網頁版：\n1. 開始練習\n2. 在屏幕右下角，點擊<b>左數第三個圖標</b>以翻轉視頻"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1216
  override val VIDEO_ACCIDENTALLY_MIRRORED_QUESTION = "視頻動作和語音引導的指示相反。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1225
  override val VIDEO_FREEZING_ANSWER = "以下是您可以尝试的几件事：\n\n1. 卸载并重新安装应用程序\n\n2. 切换到较低质量的视频。开始一次练习，然后暂停。点击右上角的<b>齿轮图标</b>。点击<b>视频质量</b>。您应该可以看到更高和更低质量视频的选项。此设置仅在瑜伽应用程序上可用。\n\n3. 仅限网络：尝试使用不同的浏览器。Down Dog在Safari，Firefox和Chrome上运行效果最佳。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1215
  override val VIDEO_FREEZING_QUESTION = "練習過程中，我的視頻卡住了。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1201
  override val VIDEO_MODEL_ANSWER = "目前我們只為每個APP提供一位模特。隨著我們持續發展，我們希望能為您提供更多選擇！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1190
  override val VIDEO_MODEL_QUESTION = "能不能切換視頻裡的模特？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=670
  override val VIDEO_QUALITY = "視頻畫質"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2558
  override val VIEW_OFFLINE_PRACTICE = "查看线下练习"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1491
  override val VIEW_PLAYLIST_ANSWER = "您可以在完成練習後、或者從<b>歷史</b>界面中選擇練習，點擊<b>音樂</b>即可查閱練習期間播放的音樂列表！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1490
  override val VIEW_PLAYLIST_QUESTION = "我的練習期間播放過哪些曲目？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3109
  override val VIEW_POSES = "查看姿势"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=75
  override val VISUAL_TYPE_NO_INTERNET_MESSAGE = "您好像沒有連接網絡。請重新聯網，再更改屏幕內容。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=290
  override val VOICE = "人聲"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2159
  override val VOICE_ACTOR_NON_ENGLISH_SURVEY_INTRO = "我们正在向应用程序添加新的配音演员，我们需要您的意见！通过从 1 到 5 给它们打分，告诉我们您对下面每个声音的喜欢程度。请忽略任何技术/声音质量问题，并专注于它们的实际声音以及翻译听起来有多自然！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2154
  override val VOICE_ACTOR_SURVEY_INTRO = "我们正在向应用程序添加新的配音演员，我们需要您的意见！通过从 1 到 5 对每个声音进行排名，告诉我们您喜欢下面的哪些声音。请原谅任何技术/声音质量问题，并告诉我们您喜欢哪些声音！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1423
  override val WANT_REFUND_CONFIRMATION = "是否確認退款？您的訂閱將被取消，您會立即失去使用APP的會員資格。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1508
  override val WEEK_START_TITLE = "每週從哪一天開始？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1518
  override val WEEKLY_GOAL = "每週目標"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1504
  override val WEEKLY_GOAL_SELECTOR_TITLE = "設定每週目標"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1505
  override val WEEKLY_GOAL_SUBTITLE = "您每週計劃做幾次練習？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=569
  override val WHATS_UP = "請在這裡輸入反饋"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1256
  override fun X_PERCENT_COMPLETE(p0: Any) = "${p0}％完成"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=378
  override val YEARLY = "每年"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1289
  override val YEARLY_CAPITALIZED = "年度"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1731
  override val YES_SIGN_UP = "是的，註冊"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=291
  override val YES_STRING = "是"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1060
  override val YOGA = "瑜伽"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=501
  override val YOGA_FOR_BEGINNERS = "初學者瑜伽"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=757
  override val YOGA_GOOGLE_FIT_DESCRIPTION = "下犬瑜伽Down Dog練習"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1493
  override val YOGA_NIDRA_INFO_ANSWER = "瑜伽休眠是一种深度放松的引导冥想。在主要的瑜伽应用程序中，您可以在练习<b>类型</b>下找到它。\n\n注意：<b>瑜伽休眠只有音频</b> - 不会有视频。\n\n很多人喜欢在应用程序中将<b>音乐</b>设置为自然声音、环境、脑波或钢琴和弦乐。试试看哪一种你更喜欢！\n\n如果你是瑜伽休眠的新手，我们建议你在<b>指导类型</b>设置为<b>完全解释</b>或<b>默认</b>的情况下听。\n\n你也可以使用瑜伽休眠来入睡！选择瑜伽休眠作为你的练习类型后，转到<b>提升</b>并将你的提升设置为<b>睡眠</b>！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1492
  override val YOGA_NIDRA_INFO_QUESTION = "瑜伽尼達拉是什麼？"
}
